
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryTrials, QueryTrialsResponse, Trial } from "@/api/dtos";
import { useMemo } from "react";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';
import { AppSettings } from "@/AppSettings";

const getAdditionalState = (response?: SWRResponse<QueryTrialsResponse, QueryTrialsResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, Trial>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}) : undefined
});

const sortData = (a: Trial, b: Trial) => a.name! > b.name! ? 1 : -1;

export const useTrials = (query?: Partial<Trial>, configuration?: SWRConfiguration | undefined) => {
    return useCachedDataQuery(QueryTrials, { sortData, getAdditionalState, channel: AppSettings.channels.trial }, query, configuration);
}

export default useTrials;